var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavIconBildung(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.3 53.3H95C96.1 51.9 96.7 50.2 96.7 48.3V38.3C96.7 33.7 93 30 88.4 30H87.5C89.1 28.2 90.1 25.9 90.1 23.3C90.1 17.8 85.6 13.3 80.1 13.3C74.6 13.3 70.1 17.8 70.1 23.3C70.1 25.9 71.1 28.2 72.7 30H71.8C67.8 30 64.4 32.9 63.6 36.7H48.3C47.6 36.7 47 37.1 46.8 37.7L40.6 53.3H30V43.3H35C35.4 43.3 35.9 43.1 36.2 42.8L51.2 27.8C51.9 27.1 51.9 26.1 51.2 25.4L46.2 20.4C45.5 19.7 44.5 19.7 43.8 20.4L32.6 31.7H25.7C27.3 29.9 28.3 27.6 28.3 25C28.3 19.5 23.8 15 18.3 15C12.8 15 8.3 19.5 8.3 25C8.3 27.6 9.3 29.9 10.9 31.7H8.3C3.7 31.7 0 35.4 0 40V48.3C0 50.2 0.7 51.9 1.7 53.3C0.7 53.3 0 54.1 0 55V61.7C0 62.6 0.7 63.4 1.7 63.4H3.4V98.4C3.4 99.3 4.1 100.1 5.1 100.1H95.1C96 100.1 96.8 99.4 96.8 98.4V63.4H98.5C99.4 63.4 100.2 62.7 100.2 61.7V55C100 54.1 99.3 53.3 98.3 53.3ZM80 16.7C83.7 16.7 86.7 19.7 86.7 23.4C86.7 27.1 83.7 30.1 80 30.1C78.8 30.1 77.7 29.7 76.7 29.2C78.7 28 80 25.9 80 23.5H76.7C76.7 25 75.6 26.3 74.2 26.7C73.7 25.7 73.3 24.7 73.3 23.5C73.3 19.7 76.3 16.7 80 16.7ZM71.7 33.3H88.4C91.2 33.3 93.4 35.5 93.4 38.3V48.3C93.4 51.1 91.2 53.3 88.4 53.3H78.4V48.3H86.7C87.6 48.3 88.4 47.6 88.4 46.6V40H85V45H76.7C75.8 45 75 45.7 75 46.7V53.4H69.1L74.9 39C75.1 38.5 75 37.9 74.7 37.4C74.4 36.9 73.9 36.7 73.3 36.7H67C67.7 34.7 69.5 33.3 71.7 33.3ZM49.5 40H70.9L65.6 53.3H44.1L49.5 40ZM18.3 18.3C22 18.3 25 21.3 25 25C25 28.7 22 31.7 18.3 31.7C14.6 31.7 11.6 28.7 11.6 25C11.7 21.3 14.7 18.3 18.3 18.3ZM3.3 40C3.3 37.2 5.5 35 8.3 35H33.3C33.7 35 34.2 34.8 34.5 34.5L45 24L47.6 26.6L34.3 40H28.3C27.4 40 26.6 40.7 26.6 41.7V53.4H23.3V46.7C23.3 45.8 22.6 45 21.6 45H11.6V41.7H8.3V46.7C8.3 47.6 9 48.4 10 48.4H20V53.4H8.3C5.5 53.4 3.3 51.2 3.3 48.4V40ZM93.3 96.7H6.7V63.3H93.4V96.7H93.3ZM96.7 60H3.3V56.7H8.3H21.6H41.6H66.6H76.6H88.3H96.6V60H96.7Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3 66.7H10V70H13.3V66.7Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 66.7H16.7002V70H20.0002V66.7Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5998 66.7H23.2998V70H26.5998V66.7Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3 73.3H10V76.6H13.3V73.3Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 73.3H16.7002V76.6H20.0002V73.3Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3 80H10V83.3H13.3V80Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9998 16.7H33.2998V21.7C33.2998 22.4 33.6998 23 34.2998 23.2C34.4998 23.3 34.6998 23.3 34.8998 23.3C35.2998 23.3 35.7998 23.1 36.0998 22.8L42.2998 16.6H56.5998C57.4998 16.6 58.2998 15.9 58.2998 14.9V1.7C58.2998 0.8 57.5998 0 56.5998 0H29.9998C29.0998 0 28.2998 0.7 28.2998 1.7V15C28.2998 15.9 29.0998 16.7 29.9998 16.7ZM31.6998 3.3H54.9998V13.3H41.6998C41.2998 13.3 40.7998 13.5 40.4998 13.8L36.6998 17.6V15C36.6998 14.1 35.9998 13.3 34.9998 13.3H31.6998V3.3Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3 6.70001H35V10H38.3V6.70001Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0002 6.70001H41.7002V10H45.0002V6.70001Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5998 6.70001H48.2998V10H51.5998V6.70001Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0002 45H56.7002V48.3H60.0002V45Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_304_3751"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIconBildung);
export default __webpack_public_path__ + "static/media/Nav-Icon-Bildung.51dbebb1be3d8899fc723aa9b7afb87b.svg";
export { ForwardRef as ReactComponent };